import { useForm, Controller } from 'react-hook-form'
import { useClassificationTask } from '../../../shared/context/classificationTaskContext'
import { useUtiles } from '../../../shared/context/utilesContext'
import { Box, Grid, Button, TextField } from '@mui/material'
export const CreateClassificationComponent = ({ number }) => {

    const { control, handleSubmit, formState: { errors } } = useForm()

    const { createClassificationTask, loadingClassificationTask } = useClassificationTask()
    const { restorePreviousComponent, setAlertSnackbar } = useUtiles()
    const handleCreateClassification = async (data) => {
        try {
            await createClassificationTask({...data, number})
            
            // Mostrar mensaje de éxito
            setAlertSnackbar({
                open: true,
                message: 'Clasificación creada exitosamente',
                severity: 'success'
            })
            
            // Restaurar el componente anterior
            restorePreviousComponent()
        } catch (error) {
            setAlertSnackbar({
                open: true,
                message: error.message || 'Error al crear la clasificación',
                severity: 'error'
            })
        }


    }

    return (
        <Box sx={{
            padding: '10px',
        }}>
            <form onSubmit={handleSubmit(handleCreateClassification)}>
                <Grid container spacing={2}>
                    <Grid item size={{ xs: 12, }}>
                    <Controller
                        control={control}
                        name="value"
                        rules={{ required: 'Este campo es requerido' }}
                        render={({ field }) => (
                            <TextField fullWidth placeholder="Nombre" {...field} error={!!errors.value} helperText={errors.value?.message} />
                        )}
                    />
                </Grid>
                <Grid item size={{ xs: 12}}>
                        <Button type="submit" variant="contained" color="primary">Crear</Button>
                        <Button 
                            variant="contained" 
                            color="disabled" 
                            sx={{ ml: 1 }}
                            onClick={restorePreviousComponent}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Box>
    )
}